import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import "./App.css";
import Landing from "./components/landing/landing";
import Dashboard from "./components/dashboard/dashboard";
import Verify from "./components/SignUp/verify";
import Transaction from "./components/transactions/transaction";
import Wallet from "./components/wallet/wallet";
import { React } from "react";
import Settings from "./components/settings/settings";
import Withdraw from "./components/withdraw/withdraw";
import Help from "./components/help/help";
import Login2Pin from "./components/Login/login2Pin";
import Login2Pass from "./components/Login/login2Pass";
import SignUp2 from "./components/SignUp/signup2";

function App() {
  function hasJWT() {
    let flag = false;
    // let token = localStorage.getItem("jwtToken");
    if (localStorage.getItem("jwtToken")) {
      flag = true;
    }

    return flag;
  }

  function DashboardRouteComponent() {
    if (hasJWT()) {
      return <Dashboard />;
    }
    return <Navigate to="/" replace={true} />;
  }
  function TransactionRouteComponent() {
    if (hasJWT()) {
      return <Transaction />;
    }
    return <Navigate to="/" replace={true} />;
  }
  function WalletRouteComponent() {
    if (hasJWT()) {
      return <Wallet />;
    }
    return <Navigate to="/" replace={true} />;
  }
  function HelpRouteComponent() {
    if (hasJWT()) {
      return <Help />;
    }
    return <Navigate to="/" replace={true} />;
  }
  function WithdrawRouteComponent() {
    if (hasJWT()) {
      return <Withdraw />;
    }
    return <Navigate to="/" replace={true} />;
  }
  function SettingRouteComponent() {
    if (hasJWT()) {
      return <Settings />;
    }
    return <Navigate to="/" replace={true} />;
  }
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Landing />} />
          {/* <Route exact path="/signin" element={<Login />} /> */}
          <Route exact path="/signinpin" element={<Login2Pin />} />
          <Route exact path="/signinpass" element={<Login2Pass />} />
          <Route exact path="/signup" element={<SignUp2 />} />
          <Route exact path="/verify" element={<Verify />} />
          <Route path="*" element={<Navigate to="/" replace={true} />} />

          <Route path="/dashboard" element={<DashboardRouteComponent />} />
          <Route path="/transaction" element={<TransactionRouteComponent />} />
          <Route path="/wallet" element={<WalletRouteComponent />} />
          <Route path="/setting" element={<SettingRouteComponent />} />
          <Route path="/withdraw" element={<WithdrawRouteComponent />} />
          <Route path="/help" element={<HelpRouteComponent />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
